// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"06288787","206":"7b5444ba","416":"a411aa23","787":"d1d4a2c2"}[chunkId] + ".chunk.js";
};